import VenuesApi from "../api/venueApi";
import * as types from "./actionTypes";

function getAllVenuesStarted() {
  return { type: types.VENUES_GET_ALL_STARTED };
}
export function getAllVenuesFulfilled(venues: any) {
  return { type: types.VENUES_GET_ALL_FULFILLED, payload: venues };
}
function getAllVenuesRejected(error: any) {
  return {
    type: types.VENUES_GET_ALL_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

export function getAllVenues() {
  return (dispatch: any) => {
    dispatch(getAllVenuesStarted());
    VenuesApi.getAllVenues()
      .then((venues) => dispatch(getAllVenuesFulfilled(venues)))
      .catch((er) => dispatch(getAllVenuesRejected(er)));
  };
}
